import { MessageWithContext, MessageContents, IMessage } from '../message';

type MessagesGetWithIdQuery = { withId: string };
export function isMessagesGetWithIdQuery(query: any): query is MessagesGetWithIdQuery {
    return typeof query.withId === 'string';
}
type MessagesGetBeforeQuery = { beforeTime: string; beforeId: string };
export function isMessagesGetBeforeQuery(query: any): query is MessagesGetBeforeQuery {
    return typeof query.beforeTime === 'string';
}
type MessagesGetAfterQuery = { afterTime: string; afterId: string };
export function isMessagesGetAfterQuery(query: any): query is MessagesGetAfterQuery {
    return typeof query.afterTime === 'string';
}

export type MessagesGetQuery = {
    chatId: string;
    limit?: string;
} & (Record<string, never> | MessagesGetWithIdQuery | MessagesGetBeforeQuery | MessagesGetAfterQuery);

export interface MessagesGetResponse<IsJSON extends boolean = true> {
    messages: IMessage<IsJSON, true>[];
    minTime: number | false;
    maxTime: number | false;
}

export type MessagesSearchQuery = {
    chatId?: string;
    search: string;
    skip?: string;
    limit?: string;
};

export interface MessagesSearchResponse {
    messages: Array<MessageSearchItem>;
    totalHits: number;
}

export interface MessageSearchItem {
    id: string;
    chatId: string;
    text: string;
    highlighted?: string;
    chatTitle?: string;
    /** Timestamp in >milliseconds< */
    date: number;
    /**
     * Agent sent this message, if available.
     */
    agentUid?: string;
}

export type MessageSendBody = Omit<MessageContents, 'context' | 'forwarded'> & {
    context?: string;
};

export type MessagesSendBody = MessageSendBody[];

export type MessagesSendResponse<IsJSON extends boolean = true> = MessageWithContext<IsJSON>[];

/**
 * @todo Move other messages routes types here and deprecate old ones.
 */
export namespace Messages {

    export namespace Reactions {

        export type AddBody = {
            /**
             * Reaction emoji.
             */
            reaction: string;
        };

    }

}
